import useHeaders from "../utils/useHeaders";
import { URI_API } from "../utils/api";

const createArea = async (body: any) => {
    return await fetch(`${URI_API}/area/create`, {
        method: "POST",
        headers: useHeaders.getHeaders(),
        body: JSON.stringify(body)
    }).then((res) => res.json());
}

const editArea = async (areaId: number, body: any) => {
    return await fetch(`${URI_API}/area/edit/${areaId}`, {
        method: "PUT",
        headers: useHeaders.getHeaders(),
        body: JSON.stringify(body),
    }).then((res) => res.json());
}

const deactivateArea = async (areaId: number) => {
    return await fetch(`${URI_API}/area/deactivate/${areaId}`, {
        method: "PUT",
        headers: useHeaders.getHeaders(),
    }).then((res) => res.json());
}

export default {
    createArea,
    editArea,
    deactivateArea
}